import React from 'react';

const variants = {
  elevated:
    'tw-bg-white tw-rounded-2xl tw-shadow-lg tw-border tw-border-gray-100',
  outlined:
    'tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200',
  flat:
    'tw-bg-gray-50 tw-rounded-2xl',
};

const Card = ({
  children,
  variant = 'elevated',
  className = '',
  padding = 'tw-p-6 md:tw-p-8',
  ...props
}) => {
  return (
    <div
      className={`${variants[variant] || variants.elevated} ${padding} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
